module.exports = __webpack_public_path__ + "img/1-2.8c315d68.jpg";